import React from 'react';
import PropTypes from 'prop-types';
import polarAceWolf from '../../assets/images/polar_ace_wolf_dark.png';

function ChatRail({ chats, activeChat, onSelect }) {
  const allChat = chats.find((c) => c.type === 'all');
  const userChats = chats.filter((c) => c.type === 'user');

  const isActive = (chat) => {
    if (chat.type === 'all') return activeChat.type === 'all';
    return activeChat.type === 'user' && activeChat.owner === chat.owner;
  };

  return (
    <aside className="community-rail" aria-label="Community chats">
      <div className="community-rail__list">
        {allChat && (
          <button
            type="button"
            className={`community-rail__item community-rail__item--all ${
              isActive(allChat) ? 'community-rail__item--active' : ''
            }`}
            onClick={() => onSelect(allChat)}
            aria-label="All Chat"
            aria-current={isActive(allChat) ? 'page' : undefined}
            title="All Chat"
          >
            <WolfLogo />
          </button>
        )}

        {userChats.map((chat) => (
          <UserChatButton
            key={chat.id}
            chat={chat}
            active={isActive(chat)}
            onSelect={onSelect}
          />
        ))}
      </div>
    </aside>
  );
}

function UserChatButton({ chat, active, onSelect }) {
  const owner = chat.owner || '';
  const label = `@${owner}'s chat`;
  const initial = owner.charAt(0).toUpperCase() || '?';

  return (
    <button
      type="button"
      className={`community-rail__item ${active ? 'community-rail__item--active' : ''}`}
      onClick={() => onSelect(chat)}
      aria-label={label}
      aria-current={active ? 'page' : undefined}
      title={label}
    >
      {chat.ownerAvatar ? (
        <img
          className="community-rail__avatar"
          src={chat.ownerAvatar}
          alt=""
        />
      ) : (
        <span className="community-rail__avatar community-rail__avatar--fallback">
          {initial}
        </span>
      )}
    </button>
  );
}

function WolfLogo() {
  return (
    <img
      src={polarAceWolf}
      alt="Polar Ace"
      className="community-rail__wolf-logo"
    />
  );
}

ChatRail.propTypes = {
  chats: PropTypes.array.isRequired,
  activeChat: PropTypes.shape({
    type: PropTypes.oneOf(['all', 'user']).isRequired,
    owner: PropTypes.string,
  }).isRequired,
  onSelect: PropTypes.func.isRequired,
};

export default ChatRail;
